<template>
    <div class="houseSibReport">
        ====================》这是houseSibReport页
    </div>
</template>
<script>
export default {
    name:'houseSibReport',
      data() {
        return {
        
        }
    },
    mounted(){
        
    },
    methods: {
        
    }
}
</script>

<style>

</style>




// WEBPACK FOOTER //
// houseSibReport.vue?403fd562